import { ReactElement } from 'react';
import { BusinessImpactData } from '@blisspointmedia/bpm-types/dist/BrandEquity';
import { MedianOrMean } from '@blisspointmedia/bpm-types/dist/MMMUtils';
import { BrandEquityHeader } from '../BrandEquityHeader';
import { isQueryVolumeMetric } from '../metricNormalization';
import { BusinessImpactModelInsights } from './BusinessImpactModelInsights';
import { BusinessImpactOverview } from './BusinessImpactOverview';
import { IncrementalRoas } from './IncrementalRoas';
import { RevenueImpact } from './RevenueImpact';

interface BusinessImpactProps {
  company: string;
  groupByLevel: string;
  businessImpactData: BusinessImpactData;
  queryVolumeLongLabel: string;
  queryVolumeShortLabel: string;
  centralMeasure: MedianOrMean;
}

export const BusinessImpact = ({
  company,
  groupByLevel,
  businessImpactData,
  queryVolumeLongLabel,
  queryVolumeShortLabel,
  centralMeasure
}: BusinessImpactProps): ReactElement => {
  const {
    weeklyBrandHealthTimeSeries,
    modelOverview,
    weeklyRevenueTimeSeries,
    totalRevenueDecomposition,
    weeklyRevenueDecomposition,
    revenueImpactTakeaways,
    weeklyIncrementalRoas,
    incrementalRoasTakeaways,
    saturationData,
    decayData
  } = businessImpactData;

  return (
    <>
      <BrandEquityHeader />
      {weeklyBrandHealthTimeSeries.length > 0 &&
        weeklyRevenueTimeSeries.length > 0 &&
        Object.keys(modelOverview).length > 0 && (
          <BusinessImpactOverview
            weeklyBrandHealthTimeSeries={weeklyBrandHealthTimeSeries}
            weeklyRevenueTimeSeries={weeklyRevenueTimeSeries}
            modelOverviewAll={modelOverview}
            incrementalRoasTakeaways={incrementalRoasTakeaways}
            isQv={Object.keys(weeklyBrandHealthTimeSeries[0]).some(isQueryVolumeMetric)}
            queryVolumeLongLabel={queryVolumeLongLabel}
            queryVolumeShortLabel={queryVolumeShortLabel}
          />
        )}
      {weeklyRevenueDecomposition.length > 0 &&
        totalRevenueDecomposition.length > 0 &&
        revenueImpactTakeaways && (
          <RevenueImpact
            weeklyRevenueDecomposition={weeklyRevenueDecomposition}
            totalRevenueDecomposition={totalRevenueDecomposition}
            revenueImpactTakeaways={revenueImpactTakeaways}
          />
        )}
      {incrementalRoasTakeaways && weeklyIncrementalRoas.length > 0 && (
        <IncrementalRoas
          weeklyIncrementalRoas={weeklyIncrementalRoas}
          incrementalRoasTakeaways={incrementalRoasTakeaways}
        />
      )}
      {(Object.keys(decayData).length > 0 || Object.keys(saturationData).length > 0) && (
        <BusinessImpactModelInsights
          company={company}
          saturationDataUnformatted={saturationData}
          decayDataUnformatted={decayData}
          groupByLevel={groupByLevel}
          queryVolumeShortLabel={queryVolumeShortLabel}
          centralMeasure={centralMeasure}
        />
      )}
    </>
  );
};
